
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"レイヤー 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon ionic-ios-sunny"}},[_c('g',{attrs:{"data-name":"Group 7848"}},[_c('path',{attrs:{"data-name":"Path 463","d":"M32 52.15a2.38 2.38 0 00-2.37 2.37v7.11a2.37 2.37 0 104.74 0v-7.11A2.37 2.37 0 0032 52.15z"}}),_c('path',{attrs:{"data-name":"Path 464","d":"M32 0a2.38 2.38 0 00-2.37 2.37v7.11a2.37 2.37 0 104.74 0V2.37A2.37 2.37 0 0032 0z"}}),_c('path',{attrs:{"data-name":"Path 465","d":"M11.85 32a2.37 2.37 0 00-2.37-2.37H2.37a2.37 2.37 0 000 4.74h7.11A2.37 2.37 0 0011.85 32z"}}),_c('path',{attrs:{"data-name":"Path 466","d":"M61.63 29.63h-7.11a2.37 2.37 0 000 4.74h7.11a2.37 2.37 0 000-4.74z"}}),_c('path',{attrs:{"data-name":"Path 467","d":"M16.08 45.55a2.37 2.37 0 00-1.68.7l-5 5a2.37 2.37 0 003.35 3.35l5-5a2.38 2.38 0 00-1.68-4z"}}),_c('path',{attrs:{"data-name":"Path 468","d":"M47.92 18.45a2.35 2.35 0 001.68-.7l5-5a2.37 2.37 0 00-3.35-3.35l-5 5a2.38 2.38 0 001.68 4z"}}),_c('path',{attrs:{"data-name":"Path 469","d":"M12.73 9.37a2.37 2.37 0 00-3.36 3.35l5 5a2.38 2.38 0 003.36-3.36z"}}),_c('path',{attrs:{"data-name":"Path 470","d":"M49.6 46.24a2.37 2.37 0 00-3.35 3.36l5 5a2.37 2.37 0 003.35-3.36z"}})]),_c('path',{attrs:{"data-name":"Path 471","d":"M32 17.23A14.77 14.77 0 1046.77 32 14.77 14.77 0 0032 17.23z"}})])])
          )
        }
      }
    